import { RiWhatsappFill } from "react-icons/ri";
import { formatTime } from "V2.0/utils";
import { Tooltip } from "antd";
import BulkCampaignStatus from "../BulkCampaignStatus";
import BulkCampaignActions from "./Components/BulkCampaignActions";
import BulkChatCampaignStats from "./Components/BulkChatCampaignStats";
import { CHAT_ROW_GRID_COLS } from "./Components/Columns/Chat";

export default function BulkWhatsAppCampaign(props) {
  const {
    name,
    // assistant,
    totalContacts,
    status,
    createdAt,
    chatCampaignDetails,
    onBulkCampaignClick,
    onBulkCampaignDelete,
    onBulkCampaignDownload,
    onBulkCampaignResume,
    onBulkCampaignPause,
    onBulkCampaignCancel,
    onBulkCampaignReport,
    isViewOnly,
  } = props;

  return (
    // Old card-style row: fixed [auto_1fr_auto] columns inside an outlined, rounded card. Replaced
    // with Frontend's flat table-row grid (CHAT_ROW_GRID_COLS, Task 3/4) so columns line up with
    // BulkCampaignTableHeader. (bulk-campaign-report-ui-port, Task 5)
    // <div
    //   className="grid grid-cols-[auto_1fr_auto] gap-x-8 justify-around hover:bg-gray-100 hover:bg-gray-100 hover:outline-zinc-300 hover:cursor-pointer outline-zinc-100 rounded-lg p-4 outline"
    //   onClick={onBulkCampaignClick}
    // >
    <div
      className={`grid ${CHAT_ROW_GRID_COLS} items-center gap-x-4 hover:bg-gray-50 hover:cursor-pointer px-4 py-3`}
      onClick={onBulkCampaignClick}
    >
      <div className="flex gap-x-4 min-w-0">
        <div className="flex">
          <RiWhatsappFill className="size-6 text-green-500 shrink-0" />
        </div>
        {/* Old two-stacked-lines layout: plain date text + badge-variant BulkCampaignStatus in a
            fixed w-[140px] column. Replaced with Frontend's single truncating combined line below.
            (bulk-campaign-report-ui-port, Task 5) */}
        {/* <div className="flex flex-col gap-y-2 w-[140px]">
          <Tooltip title={name}>
            <p className="truncate text-sm font-semibold">{name}</p>
          </Tooltip>
          <p className="text-xs">{formatTime(createdAt)}</p>
          <div>
            <BulkCampaignStatus status={status} />
          </div>
        </div> */}
        <div className="flex flex-col gap-y-1 min-w-0">
          <Tooltip title={name}>
            <p className="truncate text-sm font-semibold">{name}</p>
          </Tooltip>
          <p className="truncate text-xs text-zinc-500">
            {formatTime(createdAt)} ·{" "}
            <BulkCampaignStatus
              status={status}
              variant="text"
            />
          </p>
        </div>
      </div>

      {/* <div>
            <div className="flex flex-col items-start gap-y-2">
              <p className="text-xs">Status</p>
              <Badge color={CAMPAIGN_STATUS_LABEL_COLORS[status]}>
                {status}
              </Badge>
            </div>
          </div> */}
      {/* <div>{assistant}</div> */}
      {/* Old wrapping div (grid grid-cols-2 lg:grid-cols-4 2xl:grid-cols-6 gap-y-4) around
          BulkChatCampaignStats. Replaced — BulkChatCampaignStats now renders its stat cells as
          direct siblings in the row's own CHAT_ROW_GRID_COLS grid, matching the table header.
          (bulk-campaign-report-ui-port, Task 5) */}
      {/* <div className="grid grid-cols-2 lg:grid-cols-4 2xl:grid-cols-6 gap-y-4"> */}
      <BulkChatCampaignStats
        chatCampaignDetails={chatCampaignDetails}
        totalContacts={totalContacts}
      />
      {/* </div> */}
      {/* Old wrapping div (flex items-center) around BulkCampaignActions is no longer needed —
          BulkCampaignActions is now a direct grid cell sized by CHAT_ROW_GRID_COLS's trailing
          actions column. (bulk-campaign-report-ui-port, Task 5) */}
      {/* <div className="flex items-center"> */}
      <BulkCampaignActions
        isViewOnly={isViewOnly}
        bulkCampaignStatus={status}
        onBulkCampaignResume={onBulkCampaignResume}
        onBulkCampaignDelete={onBulkCampaignDelete}
        onBulkCampaignDownload={onBulkCampaignDownload}
        onBulkCampaignPause={onBulkCampaignPause}
        onBulkCampaignCancel={onBulkCampaignCancel}
        onBulkCampaignReport={onBulkCampaignReport}
      />
      {/* </div> */}
    </div>
  );
}
